export const priorityIndex = {
    routine : "RUTINA",
    stat: "URGENCIA"
}

export const translatePriority = (priority) => {
    return priorityIndex[priority] || priority;
}
